import React, { useState } from 'react'
import { TextField, Toggle, ToggleGroup } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import Editable from '../../common/Editable'

export default function EditableTreeField({ fieldKey, value, isEditing, getValue, editableFieldsRef }) {
  const [fieldValue, setFieldValue] = useState(value)
  const { t } = useTranslation()

  const setTreeField = (changeValue) => {
    setFieldValue(changeValue)
    editableFieldsRef.current[fieldKey] = changeValue
  }

  const getEditableElement = () => {
    switch (fieldKey) {
      case 'hidden':
      case 'private':
      case 'researcherTree':
      case 'tombstoned':
      case 'ordinancesAllowed':
      case 'useSecondaryAdminQueues':
        return (
          <ToggleGroup>
            <Toggle
              label={t(`tree.info.${fieldKey}`, fieldKey)}
              name={fieldKey}
              checked={fieldValue}
              onChange={(e) => {
                setTreeField(e.target.checked)
              }}
            />
          </ToggleGroup>
        )
      default: {
        if (fieldValue) {
          return (
            <TextField
              placeholder={fieldValue}
              value={fieldValue}
              onChange={(e) => {
                setTreeField(e.target.value)
              }}
            />
          )
        }
        return null
      }
    }
  }

  return (
    <Editable text={getValue(fieldKey, fieldValue)} isEdit={isEditing}>
      {getEditableElement(fieldKey, fieldValue)}
    </Editable>
  )
}
